/**
 * Blacklist Item
 */
const yup = require('yup');

const {
  requiredString,
  validateObject,
  requiredDate,
  requiredNumber
} = require('../utils');

const COLLECTION = 'whitelist';
const SCHEMA = yup.object().shape({
  userIP: requiredString(),
  expirationDate: requiredDate(),
  dailyLimit: requiredNumber(),
  domain: requiredString()
});

async function validate(whitelistItem) {
  return validateObject(SCHEMA, whitelistItem);
}

module.exports = {
  COLLECTION,
  SCHEMA,
  validate
};